import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { renderHeaders } from "../../utils/renderHeaders";
import StartAuthScreen from "../../components/onboarding/StartAuthScreen/StartAuthScreen";
import useVerifyAuth from "../../hooks/useVerifyAuth";
import LoadingOverlay, {
  OverlayVariant,
} from "../../components/LoadingOverlay/LoadingOverlay";
import {
  clearStoredAuthCancelledError,
  getStoredAuthCancelledError,
} from "../../utils/storage";
import { showErrorToast } from "../../utils/show-toast";

function LoginStartFlowPage() {
  const { t } = useTranslation();
  const { verificationInProgress: isVerifyingAuth, authFlowText } =
    useVerifyAuth();

  useEffect(() => {
    if (!getStoredAuthCancelledError()) return;
    showErrorToast(t("toasts:unable_to_login"));

    return () => {
      clearStoredAuthCancelledError();
    };
  }, [t]);

  return (
    <>
      {renderHeaders({
        title: t("metadata:log_in_for_free_hyper_gaming_app"),
        description: t("metadata:log_in_seo_description"),
        ogTitle: t("metadata:win_cash_in_1v1_and_multiplayer_games"),
      })}

      <StartAuthScreen />

      {isVerifyingAuth && (
        <LoadingOverlay
          variant={OverlayVariant.SPINNER}
          loadingText={authFlowText}
        />
      )}
    </>
  );
}

export default LoginStartFlowPage;
